module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/water_2489af.jpg";